import { css } from 'styled-components';

export const baseTextStyles = css`
  font-size: var(--font-size-p);
  line-height: var(--line-height-p);

  color: ${(props) => props.color};
`;
